
/**
 * Simple FIFO queue.
 */
export class Queue<T> {

    protected stack: T[] = []
    public forEach = this.stack.forEach // tslint:disable-line:member-ordering

    public find(p: (o: T) => boolean): T {
        return this.stack.find(p)
    }

    public peek(): T {
        return this.stack[0] || undefined
    }

    public push(items: T | T[]): number {
        [].concat(items).forEach((item) => this.stack.push(item))
        return this.stack.length
    }

    public remove(item: T) {
        this.stack.splice(this.stack.indexOf(item), 1)
    }

    public shift(): T {
        return this.stack.shift()
    }

    public take(n: number): T | T[] {
        if (n > 1) {
            return this.stack.splice(0, n)
        }
        return this.stack.shift()
    }
}
